import { ReactNode, createContext, useState } from 'react'

interface Props {
    children: ReactNode
}

interface LoaderContext {
    showLoader: (key: string) => void
    removeLoader: (key: string) => void
}

export const LoaderContext = createContext<LoaderContext>({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    showLoader: () => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    removeLoader: () => {},
})

export function LoaderProvider(props: Props) {
    const [loaders, setLoaders] = useState<Array<string>>([])

    const showLoader = (key: string) => {
        setLoaders((l) => {
            if (l.find((x) => x === key)) return l
            return [...l, key]
        })
    }

    const removeLoader = (key: string) => {
        setLoaders((l) => l.filter((x) => x !== key))
    }

    return (
        <LoaderContext.Provider value={{ showLoader, removeLoader }}>
            {props.children}
            {loaders.length > 0 ? <span className="loader"></span> : null}
        </LoaderContext.Provider>
    )
}
